import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";

/**
 * SEC-SPLIT-01: Build mode selector.
 * REACT_APP_BUILD_MODE=PUBLIC  → renders AppPublic (17 public routes, no CRM imports)
 * REACT_APP_BUILD_MODE=CRM     → renders App (full CRM + public routes)
 * Default (unset)              → App (backwards compatible)
 *
 * At build time, Webpack inlines the env var and tree-shakes the unused branch,
 * ensuring the public bundle contains zero private CRM/Admin component imports.
 */
const BUILD_MODE = process.env.REACT_APP_BUILD_MODE || "CRM";

// Dynamic import ensures only one branch is bundled per build
let RootComponent;
if (BUILD_MODE === "PUBLIC") {
  /* eslint-disable */
  const { default: AppPublic } = require("@/AppPublic");
  /* eslint-enable */
  RootComponent = AppPublic;
} else {
  /* eslint-disable */
  const { default: App } = require("@/App");
  /* eslint-enable */
  RootComponent = App;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RootComponent />
    </QueryClientProvider>
  </React.StrictMode>,
);
